var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showBadge()
    ? _c(
        "div",
        {
          staticClass: "badge",
          class: [
            {
              badge_office:
                _vm.categoryProps === _vm.config.rootcategories.biuro
            },
            _vm.getClass()
          ]
        },
        [_c("span", [_vm._v(_vm._s(_vm.$t(_vm.getTextLabel())))])]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }